import React from 'react'
import RecipesSection from '../components/Recipes-Section/Recipes-Section'
import TopRecipes from '../components/Top-Recipes/TopRecipes'

function Recipees() {
  return (
    <div>
        <RecipesSection/>
        <TopRecipes/>
    </div>
  )
}

export default Recipees